import { useGetGuestCustomers } from 'api-hooks/guest';
import { Input } from 'baseui/input';
import { Pagination, SIZE } from 'baseui/pagination';
import DrawerHeader from 'components/common/drawer/drawer-header';
import { DrawerBody, DrawerFooter } from 'components/common/drawer/styles';
import EmptyView from 'components/common/empty-view';
import LoadingComponent from 'components/common/loading';
import Separator from 'components/common/separator';
import CustomFormControl from 'components/elements/custom-form-control';
import { FooterDivider } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useDebouncedCallback } from 'use-debounce';

import CustomerCard from './customer-card';

interface Props {
  guestId: string;
  onClose: () => void;
}

export default function ListCustomerPanel(props: Props) {
  const { t } = useTranslation();
  const [page, setPage] = React.useState(1);
  const [query, setQuery] = React.useState<string | undefined>();
  const { data, isFetching } = useGetGuestCustomers({
    id: props.guestId,
    params: { page, q: query },
  });
  const onQueryChange = useDebouncedCallback(
    (event) => {
      setQuery(event?.target?.value || '');
    },
    800,
    { trailing: true },
  );

  return (
    <>
      <DrawerHeader
        title={t('guest:list_customer')}
        onClose={props.onClose}
        $style={{ backgroundColor: 'white' }}
      />
      <DrawerBody>
        <CustomFormControl label={t('common:search').toString()}>
          <Input
            placeholder={t('guest:search_customer')}
            overrides={{
              Input: {
                style: {
                  paddingTop: '2px',
                  paddingBottom: '2px',
                },
              },
            }}
            onChange={onQueryChange}
          />
        </CustomFormControl>
        {isFetching ? (
          <LoadingComponent />
        ) : (
          <>
            {data?.data.length ? (
              (data?.data || []).map((item) => (
                <React.Fragment key={item.id}>
                  <CustomerCard onDismiss={props.onClose} customer={item} />
                  <Separator gap={16} />
                </React.Fragment>
              ))
            ) : (
              <EmptyView />
            )}
            <FooterDivider />
            {data?.meta && (
              <DrawerFooter $style={{ justifyContent: 'center' }}>
                <Pagination
                  size={SIZE.mini}
                  overrides={{
                    MaxLabel: {
                      style: {
                        fontSize: '12px',
                      },
                    },
                    Select: {
                      props: {
                        overrides: {
                          Popover: {
                            props: {
                              overrides: {
                                Body: {
                                  style: {
                                    zIndex: 100,
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  }}
                  numPages={data?.meta.lastPage || 0}
                  currentPage={page}
                  onPageChange={({ nextPage }) => {
                    setPage(
                      Math.min(Math.max(nextPage, 1), data?.meta.lastPage),
                    );
                  }}
                />
              </DrawerFooter>
            )}
          </>
        )}
      </DrawerBody>
    </>
  );
}
